import { render, staticRenderFns } from "./ListTitle.vue?vue&type=template&id=70aed7e6&scoped=true&"
import script from "./ListTitle.vue?vue&type=script&lang=js&"
export * from "./ListTitle.vue?vue&type=script&lang=js&"
import style0 from "./ListTitle.vue?vue&type=style&index=0&id=70aed7e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aed7e6",
  null
  
)

export default component.exports